module.exports = __webpack_public_path__ + "static/logo-full-d29532c966a6902ae159cc6aee3f6297.png";